import script from "./PrivacyPolicyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivacyPolicyView.vue?vue&type=script&setup=true&lang=ts"

import "./PrivacyPolicyView.vue?vue&type=style&index=0&id=4e8cc756&lang=css"

const __exports__ = script;

export default __exports__